import React from "react";
import { useTranslation } from "react-i18next";

function ProductsStateMessage({ title, message, onRetry }) {
  const { t } = useTranslation();

  return (
    <div className="caf-products-state mx-auto max-w-lg px-4 py-16 text-center">
      <p className="caf-section-title text-xl">{title}</p>
      {message ? (
        <p className="caf-section-subtitle mt-2">{message}</p>
      ) : null}
      {onRetry ? (
        <button
          type="button"
          className="caf-btn caf-btn--outline mt-6 px-6 py-2.5 text-sm"
          onClick={onRetry}
        >
          {t("Try again")}
        </button>
      ) : null}
    </div>
  );
}

export default ProductsStateMessage;
